import { featureItems } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-3">
          为什么选择麻花影院
        </h2>
        <p className="text-foreground-500 text-center text-sm md:text-base mb-10">
          四大优势，打造极致观影体验
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {featureItems.map((item) => (
            <div
              key={item.id}
              className="rounded-xl bg-background-100 border border-background-200/70 p-6 text-center group hover:border-primary-200 transition-all duration-300"
            >
              <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-2xl bg-primary-100 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={`${item.icon} text-2xl`}></i>
              </div>
              <h3 className="text-sm font-bold text-foreground-800 mb-2">{item.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}